@if (Visible) {
    <nav class="agu-pager" aria-label="Pagination">
        <button type="button" class="agu-pager__pg" (click)="GoTo(Page - 1)" [disabled]="Page <= 1" aria-label="Previous page">‹</button>
        @for (page of Pages; track page) {
            <button type="button" class="agu-pager__pg" [class.agu-pager__pg--active]="page === Page" [attr.aria-current]="page === Page ? 'page' : null" [attr.aria-label]="'Page ' + page" (click)="GoTo(page)">{{ page }}</button>
        }
        <button type="button" class="agu-pager__pg" (click)="GoTo(Page + 1)" [disabled]="!CanNext" aria-label="Next page">›</button>
    </nav>
}
